/**
 *
 * @param length Amount of items
 * @param baseTime Time that 1 item would give
 * @returns A time that starts at baseTime with 1 in length, and increase less per item, as items grow in size.
 * @description
 * - logarithmicTime(1, 5000) => 5000
 * - logarithmicTime(2, 5000) => 8465 _(3465 increase)_
 * - logarithmicTime(3, 5000) = 10493 _(2028 increase)_
 */
export const logarithmicTime = (length: number, baseTime: number): number =>
    Math.floor((Math.log(length) + 1) * baseTime);
